<template>
  <v-card-title>
    <slot>Crossref Login</slot>
  </v-card-title>
</template>

<script>
/**
 * Renders the default crossref login box title
 */
export default {
  name: 'LoginBoxCardTitle'
}
</script>

<style scoped>

</style>
